import React from "react";

const PrivacyPolicy = () => (
  <div
    style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "24px 16px 40px",
      lineHeight: 1.6,
      fontSize: "0.95rem",
      textAlign: "left",
    }}
  >
    <h2 style={{ marginTop: 0, marginBottom: "16px", fontSize: "1.6rem" }}>
      Privacy Policy
    </h2>

    <p style={{ marginBottom: "24px", color: "#555" }}>
      <strong>Effective:</strong> November 2025
    </p>

    <p style={{ marginBottom: "16px" }}>
      At PriorityPop, your privacy matters. This Privacy Policy explains how we
      collect, use, and safeguard your information.
    </p>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        1. Information We Collect
      </h3>
      <ul style={{ paddingLeft: "1.25rem", listStyleType: "disc", margin: 0 }}>
        <li style={{ marginBottom: "6px" }}>
          <strong>Account Information:</strong> Name, email, and login
          credentials when you register.
        </li>
        <li style={{ marginBottom: "6px" }}>
          <strong>Task Data:</strong> Tasks, preferences, categories, and
          completion history you enter.
        </li>
        <li>
          <strong>Usage Data:</strong> Log-ins, device/browser details, and
          in-app activity.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        2. How We Use Your Information
      </h3>
      <ul style={{ paddingLeft: "1.25rem", listStyleType: "disc", margin: 0 }}>
        <li style={{ marginBottom: "6px" }}>
          To operate, maintain, and improve PriorityPop.
        </li>
        <li style={{ marginBottom: "6px" }}>
          To provide AI-driven analysis of your task habits once you have enough
          data.
        </li>
        <li>
          To generate <strong>aggregated insights</strong> that compare your
          patterns to overall usage to help you prioritize.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        3. Data Sharing
      </h3>
      <ul style={{ paddingLeft: "1.25rem", listStyleType: "disc", margin: 0 }}>
        <li style={{ marginBottom: "6px" }}>
          <strong>
            We do not sell or share your individual task data with third
            parties.
          </strong>
        </li>
        <li>
          We may share <strong>aggregated, anonymized statistics</strong> that
          cannot identify you personally.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        4. Data Security
      </h3>
      <p style={{ margin: 0 }}>
        We use industry-standard security measures to protect your information,
        though no system is 100% secure.
      </p>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        5. Your Rights
      </h3>
      <ul style={{ paddingLeft: "1.25rem", listStyleType: "disc", margin: 0 }}>
        <li style={{ marginBottom: "6px" }}>
          Access, update, or delete your account at any time.
        </li>
        <li>
          Request deletion of your data by contacting app@prioritypop.com.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "8px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>6. Changes</h3>
      <p style={{ margin: 0 }}>
        We may update this policy occasionally. We’ll notify you of material
        changes by email or in-app notice.
      </p>
    </section>
  </div>
);

export default PrivacyPolicy;
